export enum ExtractionPointEnums {
    /**
     * Bale is before blow room
     */
    BALE = 0,
    AFTER_MIXER = 1,
    AFTER_BLOW_ROOM = 2,
    INPUT_CARD = 3,
    CARD_SLIVER = 4,
    IDF_SLIVER = 5,
    BREAKER_DF_SLIVER_1 = 6,
    BREAKER_DF_SLIVER_2 = 7,
    LAP = 8,
    COMBED_SLIVER = 9,
    COMBER_NOIL = 10,
    FINISHER_DF_SLIVER = 11,
    FLYER = 12,
    SPINNING_YARN = 13,
    WINDING_YARN = 14,
}
